import {
	SVGButtonModal,
	CompGradientBarFeedback,
	SVGCheckedAnswer
} from "../../widgets/index";
import { hint_svg, explanation_svg } from "../../../svg/index.js";
import LevDist from "../../../classes/LevDist";
import internationalConverter from "../../../funcs/international_converter";

import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { recordItem } from "../../../store/activityStateReducers";

const CompTextField = ({
	answer_index,
	nested_answer_index,
	instant_feedback_bool,
	answer_js,
	validation_js
}) => {
	const dispatch = useDispatch();

	const { answer, hint, explanation } = answer_js;

	const [response, setResponse] = useState("");
	const [instant_feedback_jsx, setInstantFeedbackJSX] = useState(<></>);

	const [has_typing_bool, setHasTyping] = useState(false);

	const registerResponseState = (event) => {
		if (!has_typing_bool) {
			setHasTyping(true);
		}
		setResponse(internationalConverter(event.target.value));
	};

	// ------------------------  check answer and give feedback ---------------
	useEffect(() => {
		if (has_typing_bool) {
			// Make all elements empty fragments
			let elements_jsx = <></>;
			let fb_jsx,
				hint_jsx,
				explanation_jsx = <></>;
			// (1.1) Calc score
			// (1.2) Record the score
			// If the input field is not empty...
			// If instant feedback is true...
			// (2.1) Update CompGradientBarFeedback based on Lev distance
			// (2.2) If a hint is available, let user get it
			// (2.3) set elements_jsx to the contents of (2.1-2)
			// If the input field is empty...
			// (3.1) elements_jsx will be an empty fragmemt

			// (1.1)
			const response_exists_bool = response.trim() === "" ? false : true;
			const response_correct_bool = response.trim() === answer ? true : false;
			const score = response_correct_bool ? 1 : 0;
			let js = { answer_index, nested_answer_index, response, score };
			js["correct"] = response_correct_bool;
			dispatch(recordItem(js));

			if (response_exists_bool) {
				if (instant_feedback_bool) {
					if (response_correct_bool) {
						// (2.1)
						fb_jsx = (
							<CompGradientBarFeedback svg_width="0.4em" grad_height_n={100} />
						);
					} else {
						// (2.1)
						const lev_dist = new LevDist(answer).measureDistance(
							response.trim()
						);
						fb_jsx = (
							<CompGradientBarFeedback
								svg_width="0.4em"
								grad_height_n={lev_dist}
							/>
						);
						// (1.2)
						if (hint !== undefined) {
							hint_jsx = (
								<SVGButtonModal
									svg={hint_svg}
									tooltip="Show hint"
									modal_html={hint}
								/>
							);
						}
					}
				}
				elements_jsx = (
					<>
						{fb_jsx} {hint_jsx} {explanation_jsx}
					</>
				);
			} else {
				// (3.1)
				elements_jsx = <></>;
			}
			setInstantFeedbackJSX(elements_jsx);
		}
	}, [
		response,
		answer,
		hint,
		instant_feedback_bool,
		answer_index,
		nested_answer_index,
		has_typing_bool,
		dispatch
	]);
	// ------------------------------------------------------------------------

	// ------------------------  check answer and give feedback ---------------
	const correct_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.results_a[answer_index].correct_a[nested_answer_index];
		} catch (e) {
			res = false;
		}
		return res;
	});
	const items_show_checkanswer_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.items_show_checkanswer_bool;
		} catch (e) {
			res = false;
		}
		return res;
	});
	const items_show_explanation_bool = useSelector((state) => {
		let res;
		try {
			res = state.activityStates.items_show_explanation_bool;
		} catch (e) {
			res = false;
		}
		return res;
	});	
	const [checked_answer_jsx, setCheckedAnswerJSX] = useState(<></>);
	useEffect(() => {
		let jsx_a = [
			<span key={1}></span>,
			<span key={2}> </span>,
			<span key={3}></span>
		];
		if (items_show_checkanswer_bool) {
			const correct_response = answer;
			jsx_a[0] = (
				<span key={1}>
					<SVGCheckedAnswer
						value={correct_bool ? "correct" : "incorrect"}
						height={30}
					/>
					{correct_bool ? (
						<></>
					) : (
						<span style={{ marginRight: 10, lineHeight: 1 }}>
							&nbsp;&rarr;&nbsp;{correct_response}
						</span>
					)}
				</span>
			);
		}
		if (items_show_explanation_bool) {
			jsx_a[2] = (
				<span key={3}>
					{explanation === undefined ? (
						<></>
					) : (
						<SVGButtonModal
							svg={explanation_svg}
							tooltip={"See explanation"}
							modal_html={explanation}
						/>
					)}
				</span>
			);
		}
		let jsx;
		if (items_show_checkanswer_bool || items_show_explanation_bool) {
			jsx = <>{jsx_a}</>;
		} else {
			jsx = <></>;
		}
		setCheckedAnswerJSX(jsx);
	}, [
		items_show_checkanswer_bool,
		items_show_explanation_bool,
		correct_bool,
		instant_feedback_bool,
		answer,
		explanation
	]);
	// ------------------------------------------------------------------------

	const jsx = (
		<>
			{checked_answer_jsx}
			<input
				style={{ lineHeight: 2 }}
				type="text"
				value={response}
				onChange={registerResponseState}
			/>
			{instant_feedback_jsx}
		</>
	);

	return jsx;
};

export default CompTextField;
